module.exports = __webpack_public_path__ + "img/SSLRLOC.dece2546.svg";